import { combineReducers } from 'redux';
// import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import locale, { LocaleState } from './locale';
import authentication from '../../modules/user/service/store/reducer';
import global from '../../modules/global/service/store/reducer';
import cms from '../../modules/cms/service/store/reducer';
import rules from '../../modules/rules/service/store/reducer';
import contact from '../../modules/contact/service/store/reducer';
import contract from '../../modules/contract/service/store/reducer';
import claim from '../../modules/claim/service/store/reducer';
import gtm from '../../modules/gtm/service/store/gtm.reducer';
import document from '../../modules/document/service/store/reducer';
import finance from '../../modules/financial/service/store/reducer';
import account from '../../modules/account/service/store/reducer';
import logistic from '../../modules/logistic/service/store/reducer';
import sellingPoint from '../../modules/sellingPoint/service/store/reducer';

import { AuthenticationState } from 'app/modules/user/service/store/state';
import { ContactState } from 'app/modules/contact/service/store/state';
import { GlobalState } from 'app/modules/global/service/store/state';
import { CmsState } from 'app/modules/cms/service/store/state';
import { RulesState } from 'app/modules/rules/service/store/state';
import { ContractState } from 'app/modules/contract/service/store/state';
import { ClaimState } from 'app/modules/claim/service/store/state';
import { GtmState } from 'app/modules/gtm/service/store/gtm.state';
import { DocumentState } from 'app/modules/document/service/store/state';
import { FinanceState } from 'app/modules/financial/service/store/state';
import { LogisticState } from 'app/modules/logistic/service/store/state';
import { SellingPointState } from 'app/modules/sellingPoint/service/store/state';
import { AccountState } from 'app/modules/account/service/store/state';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

export interface IRootState {
  readonly authentication: AuthenticationState;
  readonly global: GlobalState;
  readonly cms: CmsState;
  readonly rules: RulesState;
  readonly contract: ContractState;
  readonly claim: ClaimState;
  readonly locale: LocaleState;
  readonly gtm: GtmState;
  readonly document: DocumentState;
  readonly finance: FinanceState;
  readonly logistic: LogisticState;
  readonly account: AccountState;
  readonly contact: ContactState;
  /* jhipster-needle-add-reducer-type - JHipster will add reducer type here */
  // readonly loadingBar: any;
  readonly sellingPoint: SellingPointState;
}

const rootReducer = combineReducers<IRootState>({
  authentication,
  global,
  cms,
  contract,
  rules,
  locale,
  claim,
  gtm,
  document,
  finance,
  logistic,
  account,
  contact,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  // loadingBar,
  sellingPoint,
});

export default rootReducer;
